import { Card, Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const PickupStore = {
  Address: styled(Text)`
    text-transform: capitalize;
  `,

  Card: styled(Card)`
    margin: ${theme.space[3]} 0;

    span {
      display: block;
    }
  `,

  PickupStoreInfo: styled('div')`
    display: grid;
    grid-gap: ${theme.space[1]};
  `,
};
